import React, { useContext, useReducer, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import MaterialTable from "material-table";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/AddBox";
import DataService from "../../../../../Service";
import ManageModules from "./manage_modules";
import {
  Typography,
  Button,
  makeStyles,
  TextField,
  InputAdornment,
  Tooltip,
} from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import Popover from "@material-ui/core/Popover";
import UpdateIcon from "@material-ui/icons/Update";
import { TooltipWrapper } from "../../../../../Common/Utils/common_utils";
import SearchIcon from "@material-ui/icons/Search";
import { Autocomplete } from "@material-ui/lab";
import SetupAutoComplete from "../SetupAutoComplete";

const useStyles = makeStyles((theme) => ({
  buttonShadow: {
    textTransform: "inherit",
  },
  miTablebox: {
    "& .MuiFormControl-root": {
      width: "25%",
    },
  },
  tooltipMaxWidth: {
    maxWidth: "450px",
  },
  tooltipMinWidth: {
    maxWidth: "300px",
  },
}));

export default function SimpleAction() {
  const classes = useStyles();
  const [currentSelection, setCurrentSelection] = useState({});
  const [moduleSetups, setModuleSetups] = useState([]);
  const [action, setAction] = useState(null);
  const [modules, setModules] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(100);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [openPopover, setPopover] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const tableOptions = {
    search: false,
  };
  const columns = [
    {
      title: "Module name",
      field: "module_name",
      customSort: (a, b) => {
        const nameA = a.module_name.toLowerCase();
        const nameB = b.module_name.toLowerCase();

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      },
    },
    {
      title: "Description",
      field: "description",
    },
  ];

  useEffect(() => {
    moduleSetup();
  }, [page, pageSize, searchText]);

  const moduleSetup = () => {
    setLoading(true);
    const params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
      search_keyword: searchText,
    };
    DataService.getDirectData(`/module_setups/listing_modules`, params)
      .then((res) => {
        setTotalCount(res["total_count"]);
        if (res.modules) {
          let moduleSetups = res["modules"];
          setModuleSetups(res.modules);
          // setModuleSetups(moduleSetups.concat(res['modules']));
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  // const handleClose = (dataDispatch, newData) => {
  //     if (action === 'create' && newData && newData.id) {
  //         const newList = { ...data, data: [newData].concat(data.data) };
  //         TableAction.addDataToList(dispatch, dataDispatch, newList);
  //     }
  const handleClose = (data, id) => {
    let moduleList = [];

    // const newList = { ...data, data: [newData].concat(data.data) };
    // TableAction.addDataToList(dispatch, dataDispatch, newList);
    if (action === "create" && data && data.id) {
      // moduleList = { ...moduleSetups, moduleSetups: [data].concat(data.data) }
      moduleList = [data].concat(moduleSetups);
      setModuleSetups(moduleList);
    } else if (data && data.id) {
      moduleList = modules.map((base) => {
        if (base.id === data.id) {
          return data;
        }
        return base;
      });
      setModules(moduleList);
    } else if (!data && id) {
      moduleList = modules.filter((base) => base.id !== id);
      setModules(moduleList);
    }
    setAction(null);
    setCurrentSelection({});
  };

  const moduleValues = moduleSetups.map((el) => el.module_name);
  const descValues = moduleSetups.map((el) => el.description);
  const dropdownValues = moduleValues.concat(descValues);
  const searchSelectHandler = (option) => {
    setSearchText(option);
    setPage(0);
  };
  return (
    <div className={classes.miTablebox}>
      <SetupAutoComplete
        type="modules"
        searchSelectHandler={searchSelectHandler}
      />
      <MaterialTable
        title=""
        // options={tableOptions}
        options={{
          search: false,
          actionsColumnIndex: -1,
          searchFieldAlignment: "left",
          pageSize: pageSize,
          emptyRowsWhenPaging: false,
          total: totalCount,
          addRowPosition: "first",
          headerStyle: {
            fontWeight: 700,
            color: "#077F83",
            position: "sticky",
            top: "0",
          },
          maxBodyHeight: "600px",
          pageSizeOptions: [20, 50, 75, 100],
        }}
        columns={columns}
        data={moduleSetups}
        totalCount={totalCount}
        page={page}
        onRowClick={(e, rowData) => {
          setCurrentSelection(rowData);
        }}
        onChangePage={(page) => {
          setPage(page);
        }}
        onChangeRowsPerPage={(pageSize) => {
          setPageSize(pageSize);
        }}
        // onSearchChange={(search) => {
        //   setSearchText(search);
        // }}
        actions={[
          {
            icon: () => <EditIcon fontSize="small" />,
            tooltip: <TooltipWrapper text="Edit" />,
            onClick: (event, rowData) => {
              setCurrentSelection(rowData);
              // setAction('edit'); commentin temporay
              setAction("editModule");
            },
          },
          {
            icon: () => <DeleteIcon fontSize="small" />,
            tooltip: <TooltipWrapper text="Delete" />,
            onClick: (event, rowData) => {
              setCurrentSelection(rowData);
              setAction("delete");
            },
          },
          // {commentin temporay
          //     icon: () => <UpdateIcon fontSize="small"/>,
          //     tooltip: 'Update',
          //     onClick: (event, rowData) => {
          //         setCurrentSelection(rowData);
          //         setAction('editModule');
          //         // setInputValue(rowData?.template_name);
          //         // setModal(true)
          //     }
          // },
          // {
          //     icon: ()=><DeleteIcon fontSize="small" />,
          //     tooltip: 'Delete',
          //     onClick: (event, rowData) => {
          //         setCurrentSelection(rowData);
          //         setAction('delete');
          //     }
          // },
          {
            icon: () => (
              <Button
                className={classes.buttonShadow}
                variant="contained"
                color="secondary"
              >
                + Setup new modules
              </Button>
            ),
            isFreeAction: true,
            onClick: (event) => setAction("create"),
          },
        ]}
      />
      {/* <MaterialTable
                title=""
                options={tableOptions}
                columns={columns}
                data={moduleSetups}
                options={{
                    actionsColumnIndex: -1
                }}
                totalCount={totalCount}
                page={page}
                onRowClick={(e, rowData) => {
                    setCurrentSelection(rowData);
                    // setPaymentDetail(true)
                }}
                onChangePage={(page) => {
                    setPage(page);
                }}
                onChangeRowsPerPage={(pageSize) => {
                    setPageSize(pageSize);
                }}
                onSearchChange={(search) => {
                    setSearchText(search);
                }}
                actions={[
                    {
                        icon: () => <EditIcon fontSize="small" />,
                        tooltip: 'Edit',
                        onClick: (event, rowData) => {
                            setCurrentSelection(rowData);
                            setAction('edit');
                        }
                    },
                    // {
                    //     icon: ()=><DeleteIcon fontSize="small" />,
                    //     tooltip: 'Delete',
                    //     onClick: (event, rowData) => {
                    //         setCurrentSelection(rowData);
                    //         setAction('delete');
                    //     }
                    // },
                    {
                        icon: () => <AddIcon color="secondary" />,
                        tooltip: 'Add',
                        isFreeAction: true,
                        onClick: (event) => setAction("create")
                    }
                ]}
            /> */}
      {openPopover === "view_more" && (
        <Popover
          anchorOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          open={openPopover === "view_more"}
          anchorEl={anchorEl}
          onBackdropClick={() => setPopover(null)}
        >
          <div>
            <Typography
              style={{
                padding: "5px 0 5px 15px",
                fontSize: "16px",
                fontFamily: "Open Sans",
              }}
              variant="subtitle2"
              color="secondary"
            >
              {currentSelection.module_name}
            </Typography>
          </div>
        </Popover>
      )}
      {action && (
        <ManageModules
          action={action}
          moduleId={currentSelection.id}
          moduleSetup={moduleSetup}
          data={currentSelection}
          handleClose={handleClose}
        />
      )}
    </div>
  );
}
